import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

export default function AccountDeletionResource() {
  const { t } = useTranslation('profile');
  const { user, isAuthReady, deleteAccount } = useAuth();
  const navigate = useNavigate();
  const [confirmation, setConfirmation] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const phrase = t('editor.deleteAccount.confirmationPhrase');

  const submit = async () => {
    if (busy || confirmation !== phrase) return;
    setBusy(true);
    setError('');
    try {
      await deleteAccount();
      navigate('/', { replace: true });
    } catch {
      setError(t('editor.deleteAccount.failure'));
      setBusy(false);
    }
  };

  return (
    <main style={{ minHeight: '100dvh', padding: 24, color: '#fff', background: '#12051f' }}>
      <section style={{ width: 'min(620px, 100%)', margin: '48px auto', padding: 24, borderRadius: 18, border: '1px solid rgba(255,100,100,.5)', background: 'rgba(40,15,55,.95)' }}>
        <h1>{t('editor.deleteAccount.resourceTitle')}</h1>
        <p style={{ lineHeight: 1.6 }}>{t('editor.deleteAccount.resourceDescription')}</p>
        {!isAuthReady ? <p role="status">{t('states.loading')}</p> : !user ? (
          <button type="button" onClick={() => navigate('/login')} style={{ padding: '12px 16px', borderRadius: 12, fontWeight: 800 }}>
            {t('editor.deleteAccount.signIn')}
          </button>
        ) : (
          <>
            <p>{t('editor.deleteAccount.confirmDescription', { phrase })}</p>
            <label htmlFor="externalDeleteConfirmation">{t('editor.deleteAccount.confirmLabel')}</label>
            <input id="externalDeleteConfirmation" value={confirmation} onChange={(event) => setConfirmation(event.target.value)} disabled={busy} autoComplete="off" style={{ display: 'block', width: '100%', boxSizing: 'border-box', margin: '8px 0 16px', padding: 12 }} />
            {error ? <p role="alert" style={{ color: '#ffaaaa' }}>{error}</p> : null}
            <button type="button" onClick={submit} disabled={busy || confirmation !== phrase} style={{ padding: '12px 16px', borderRadius: 12, border: '1px solid #ff7777', background: '#9d1636', color: '#fff', fontWeight: 800 }}>
              {busy ? t('editor.deleteAccount.deleting') : t('editor.deleteAccount.confirm')}
            </button>
          </>
        )}
      </section>
    </main>
  );
}
